import { Component } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { RosterService } from "../services/roster.service";
import { ToastService } from "../shared/toast/toast.service";

@Component({
  selector: "pps-import-roster",
  templateUrl: "./import-roster.component.html"
})
export class ImportRosterComponent{
  spinnerName: string = "spinner";
  importingFromCsv = false;
  importingFromXlsm = false;

  constructor(
    private _rosterService: RosterService,
    private _toast: ToastService,
    private _spinner: NgxSpinnerService) {
  }

  ngOnInit(){
  }
  resetRoster(){
    this._rosterService.resetRosterData()
      .subscribe(
        res => {
          if (res.succeed){
            this._toast.succeeded(res.result);
          }else{
            this._toast.failed(res.errors.join("; "));
          }
        }
      );
  }

  importRoster(){
    this._spinner.show(this.spinnerName);
    this.importingFromXlsm = true;
    this._rosterService.importRoster(
      () => {
        this._spinner.hide(this.spinnerName);
        this.importingFromXlsm = false;
      },
      (errorRes) => {
        this._spinner.hide(this.spinnerName);
        this.importingFromXlsm = false;
        this._toast.failed(`${errorRes.errors.join("; ")}`);
      });
  }

  importRosterFromCsvFile(){
    this._spinner.show(this.spinnerName);
    this.importingFromCsv = true;
    this._rosterService.importRosterFromCsv().subscribe(
      () => {
        this._spinner.hide(this.spinnerName);
      },
      (errorRes) => {
        this._spinner.hide(this.spinnerName);
        
        this._toast.failed(`${errorRes.errors.join("; ")}`);
      },
      () => this.importingFromCsv = false);
  }
}